import { PicklistRequestV2 } from "./Types/PicklistRequestV2";
import { PicklistResultV2 } from "./Types/PicklistResultV2";

export interface IPicklistApiClient {
    searchAsync(gid: string, request: Readonly<PicklistRequestV2>): Promise<PicklistResultV2>;
}
